module.exports = __webpack_public_path__ + "static/media/dew.6f1aba64.png";